// extracted by mini-css-extract-plugin
export default {"modalHeader":"ModalHeader_modalHeader__tD2K+"};